export const callFlowChart = `
flowchart TD
    Start([Start: Call Execution Initiated])
    NotPicked{Call Picked Up?}
    InProgress([Status: In Progress])
    PickedUp(["LLM: Call Picked Up"])
    InitScript([System: Play Init Script])
    
    DNDCheck{Customer says Do not disturb?}
    DNDAction([Store in DND List & Send SMS])
    
    AreYouBot{Customer asks Are you a bot?}
    AreYouBotScript([Play Are you a bot Script])
    AreYouBotSentiment{LLM Sentiment?}
    
    WhoGaveNumber{Customer asks Who gave you my number?}
    ReqCheckScript([Play Requirement Check Script])
    ReqCheckSentiment{LLM Sentiment?}
    
    Sentiment{User Sentiment after Init Script?}
    NeutralScript([Agent: Play Neutral Script])
    NeutralSentiment{Sentiment after Neutral Script?}
    
    Transfer([Transfer to Customer Care Executive])
    Stop([Stop Call])
    
    NotPickedNo([Status: Not Attended Call])

    PositiveFlow([Execute Positive Workflow])
    NegativeFlow([Execute Negative Workflow])
    NeutralFlow([Execute Neutral Workflow])

    Start --> NotPicked
    NotPicked -- No --> NotPickedNo
    NotPicked -- Yes --> InProgress --> PickedUp --> InitScript --> DNDCheck
    DNDCheck -- Yes --> DNDAction --> Stop
    DNDCheck -- No --> AreYouBot
    AreYouBot -- Yes --> AreYouBotScript --> AreYouBotSentiment
    AreYouBotSentiment -- Positive --> PositiveFlow
    AreYouBotSentiment -- Negative --> NegativeFlow
    AreYouBotSentiment -- Neutral --> NeutralFlow
    AreYouBot -- No --> WhoGaveNumber
    WhoGaveNumber -- Yes --> ReqCheckScript --> ReqCheckSentiment
    ReqCheckSentiment -- Positive --> PositiveFlow
    ReqCheckSentiment -- Negative --> NegativeFlow
    ReqCheckSentiment -- Neutral --> NeutralFlow
    WhoGaveNumber -- No --> Sentiment

    Sentiment -- Positive --> Transfer
    Sentiment -- Negative --> ConfirmTransfer{Ask Again: Want to talk to executive?}
    ConfirmTransfer -- Negative --> Stop
    ConfirmTransfer -- Positive --> Transfer
    Sentiment -- Neutral --> NeutralScript --> NeutralSentiment
    NeutralSentiment -- Positive --> PositiveFlow
    NeutralSentiment -- Negative --> NegativeFlow
    NeutralSentiment -- Neutral --> NeutralFlow
`;


